export default __webpack_public_path__ + "static/media/reimbursable-medical-expenses.c88ae9c9.svg";